import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ReactDOM from "react-dom";
import * as dialogPopupActions from '../../actions/dialogPopupActions';
import * as keyboardConstants from '../../constants/keyboardConstants';
import * as dataHelper from '../../helpers/dataHelper';
import * as appHelper  from '../../helpers/appHelper';
export class InitDialog extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            dialogPopup: this.props.dialogPopup,
            firstTabIndex: "firstTabIndex",
            lastTabIndex: "lastTabIndex",
            tabbableElements: [],
            isDialog: true,
            isOpen: false,
            guid: dataHelper.createGuid()
        };
        this.setTabbableElements = this.setTabbableElements.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.setInitialFocus = this.setInitialFocus.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
    }

    componentDidMount() {
        this.setTabbableElements();
        window.addEventListener("keydown", this.onKeyDown);
        window.addEventListener("keyup", this.onKeyUp);


    }

    componentWillReceiveProps(nextProps) {
        if (this.state.dialogPopup !== nextProps.dialogPopup) {
            this.setState({dialogPopup: Object.assign({}, nextProps.dialogPopup)});
        }
    }

    componentDidUpdate() {
        if (!this.state.isOpen && this.state.dialogPopup.isOpen) {
            this.setInitialFocus();
        }
    }

    componentWillUnmount() {
        window.removeEventListener("keydown", this.onKeyDown);
        window.removeEventListener("keyup", this.onKeyUp);
    }

    setTabbableElements() {
        let dialog = this.refs.initDialog;
        this.setState({tabbableElements: Object.assign([], dataHelper.getAllTabbableElements(dialog))});
    }

    setKeyboardAccessibility(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.props.onCloseDialog();
        }
    }

    setInitialFocus() {
        this.setState({isOpen: true});
        let firstFocus = this.state.tabbableElements[1];
        let func = this.openDialog;
        setTimeout(function () {
            firstFocus.focus();
        }, 1000);


    }

    onKeyDown(event) {
        let shiftPressed = this.state.shiftPressed;
        let tabPressed = this.state.tabPressed;

        if (event.which === keyboardConstants.ESCAPE_KEY) {
            event.preventDefault();
            this.props.actions.removeDialog();
            if(appHelper.isDefined(this.state.dialogPopup.config.sourceId)){
                let sourceElement = document.getElementById(this.state.dialogPopup.config.sourceId);
                if(appHelper.isDefined(sourceElement)){
                    sourceElement.focus();
                }
            }
        }

        if (event.which === keyboardConstants.TAB_KEY) {
            tabPressed = true;
            this.setState({
                tabPressed: tabPressed
            });
        }

        if (event.which === keyboardConstants.SHIFT_KEY) {
            shiftPressed = true;
            this.setState({
                shiftPressed: shiftPressed
            });
        }
    }

    onKeyUp(event) {
        let activeItem = document.activeElement;
        let activeItemId = activeItem.id;

        if (activeItemId === this.state.tabbableElements[0].id) {
            //go to last
            this.state.tabbableElements[this.state.tabbableElements.length - 2].focus();
        } else if (activeItemId === this.state.tabbableElements[this.state.tabbableElements.length - 1].id) {
            this.state.tabbableElements[1].focus();
        }

        this.setState({
            tabPressed: false,
            shiftPressed: false
        });
    }

    render() {

        return (
            <div className={this.state.dialogPopup.className + " " + this.state.dialogPopup.config.theme} ref={`initDialog`} id="initDialog" role="dialog"  aria-modal={this.state.isDialog} aria-labelledby="initDialog">
                <div id={`firstTabIndex_initDialog_${this.state.guid}`} tabIndex="0" role="button"/>
                <div className="dialog-header truncate-text-container guroo-dialog-header">
                    <div
                        className={`${this.state.dialogPopup.config.icon} icon-first dialog-title`}>{this.state.dialogPopup.config.title}</div>

                </div>
                <div className="dialog-body">
                    {this.state.dialogPopup.config.childComponents.map(component =>
                        <div key={"container_" + component.id} className="component-seperator">
                            {component.componentProps != null
                                ? <component.childComponent key={component.id} {...component.componentProps}/>
                                : <component.childComponent key={component.id}/>
                            }
                        </div>
                    )}
                </div>
                <div id={`lastTabIndex_initDialog_${this.state.guid}`} tabIndex="0" role="button"/>
            </div>
        );
    }
}

InitDialog.propTypes = {
    dialogPopup: PropTypes.object.isRequired,
    onCloseDialog: PropTypes.func.isRequired,
    actions: PropTypes.object.isRequired
};

//Pull in the React Router context so router is available on this.context.router.
InitDialog.contextTypes = {
    router: PropTypes.object
};

//Init
function mapStateToProps(state, ownProps) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(InitDialog);


/** WEBPACK FOOTER **
 ** ./src/components/dialogs/InitDialog.js
 **/